import { Box, Container, Divider, Typography } from "@mui/material";
import React from "react";
import ReactPlayer from "react-player";
import { PropagateLoader } from "react-spinners";
import { useAPI } from "../../../../apiContext";

const QuickPropertySearch = () => {
	const { data } = useAPI();
	return (
		<Container sx={{ pt: 3 }}>
			{data?._id ? (
				<Box
					sx={{ border: "3px solid", borderRadius: "15px", p: 1 }}
					className='borderColor'>
					{!data?.headline?.QuickPropertySearch === "off" ? (
						""
					) : (
						<>
							<Typography
								className='textColor'
								sx={{ mb: 0.5, fontWeight: 900 }}
								variant='h4'
								component='div'
								gutterBottom>
								{data?.headline?.QuickPropertySearch}
								<Divider className={`${data?.color?.hr}`} />
							</Typography>
							<ReactPlayer
								className='borderColor react-player'
								width='100%'
								url={data?.scripts?.quickPropertySearch}
								controls
								style={{ borderRadius: "15px" }}
							/>
						</>
					)}
				</Box>
			) : (
				<div className='loader'>
					<PropagateLoader size={11} />
				</div>
			)}
		</Container>
	);
};

export default QuickPropertySearch;
